import { Controller } from "@hotwired/stimulus"

/**
 * DevToolsController
 *
 * Controls the floating development tools panel visibility.
 * Toggles between collapsed (icon button) and expanded (panel with links) states.
 *
 * @example HTML structure:
 *   <div data-controller="dev-tools">
 *     <button data-dev-tools-target="toggleButton" data-action="click->dev-tools#toggle">
 *       Toggle
 *     </button>
 *     <div data-dev-tools-target="panel" class="hidden">
 *       Panel content
 *     </div>
 *   </div>
 */
export default class extends Controller {
  static targets = ["toggleButton", "panel"]

  /**
   * Toggles the panel visibility between hidden and visible states.
   *
   * @returns {void}
   */
  toggle() {
    this.panelTarget.classList.toggle("hidden")
  }

  /**
   * Closes the panel when clicking outside of it.
   * Bound on connect and removed on disconnect for proper cleanup.
   *
   * @param {Event} event - The click event
   * @returns {void}
   */
  closeOnClickOutside = (event) => {
    if (!this.element.contains(event.target)) {
      this.panelTarget.classList.add("hidden")
    }
  }

  /**
   * Lifecycle: Called when controller is connected to the DOM.
   * Sets up click-outside listener to close panel.
   *
   * @returns {void}
   */
  connect() {
    document.addEventListener("click", this.closeOnClickOutside)
  }

  /**
   * Lifecycle: Called when controller is disconnected from the DOM.
   * Cleans up event listeners to prevent memory leaks.
   *
   * @returns {void}
   */
  disconnect() {
    document.removeEventListener("click", this.closeOnClickOutside)
  }
}




